import { deleteData, getBlobData, getData, postData } from '../common/getData';
import { createHeaders } from '../common/lib/createHeaders';

import { getBaseUrl } from '../common/getBaseUrl';
import { ApiResponse } from '../types/ApiResponse';
import { BlobApiResponse } from '../types/BlobApiResponse';
import { contentTypeToDisplayName } from './lib/contentTypeToDisplayName';
import { formatSize } from './lib/formatSize';
import { LMAktMetadata } from './types/LMAktMetadata';
import { MetriaAktMetadata } from './types/MetriaAktMetadata';

const port = '8550';
const path = '/api/akt/v1/akter';

export const listAkter = async (): Promise<
  ApiResponse<MetriaAktMetadata[]>
> => {
  const formatDateAndSize = (akt: MetriaAktMetadata): MetriaAktMetadata => {
    akt.registreradTidpunkt = new Date(akt.registreradTidpunkt).toLocaleString(
      'sv-SE'
    );
    akt.storlek = formatSize(akt.storlek).message;
    return akt;
  };

  try {
    const akter = await getData<MetriaAktMetadata[]>(
      getBaseUrl(path, port),
      createHeaders()
    );

    if (akter.success) {
      return new ApiResponse(
        akter.statusCode,
        akter.data?.map((akt) => formatDateAndSize(akt))
      );
    }
    return new ApiResponse(akter.statusCode, undefined, akter.error);
  } catch (e) {
    return new ApiResponse(0);
  }
};

export const getLMAktMetadata = (
  aktbeteckning: string,
  format: string
): Promise<ApiResponse<LMAktMetadata>> =>
  postData<LMAktMetadata>(
    `${getBaseUrl(path, port)}/metadata`,
    {
      aktbeteckning: aktbeteckning.trim(),
      format: format.toLocaleUpperCase().trim(),
    },
    createHeaders()
  );

export const taBortAkter = (ids: number[]): Promise<ApiResponse> =>
  deleteData(getBaseUrl(path, port), { aktbeteckningar: ids }, createHeaders());

export const buyAkt = (
  aktbeteckning: string,
  format: string,
  kundmarke: string,
  storlek: string
): Promise<ApiResponse> =>
  postData(
    getBaseUrl(path, port),
    {
      aktbeteckning: aktbeteckning.trim(),
      format: contentTypeToDisplayName(format),
      storlek,
    },
    createHeaders(undefined, kundmarke)
  );

export const downloadAkt = (id: string): Promise<BlobApiResponse> =>
  getBlobData(`${getBaseUrl(path, port)}/${id.trim()}`, createHeaders());

